export default {"src":"/_next/static/media/boat.76485be1.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};